// Imports
import React, { Suspense } from "react"
import { Link } from "react-router-dom"

import { Fallback, Font, Button, Flexbox } from "fajny-react"

import { Container, Image, Content } from "./styles"

const CardHome = ({ card }) => {
    const { img, altImg, title, text, textBtn, toBtn, blank } = card

    return (
        <Container>
            <Suspense fallback={<Fallback $width="100%" $height={100} />}>
                <Image src={`/images/${img}.svg`} alt={altImg} fit="contain" />
            </Suspense>

            <Content>
                <Font.H5>{title}</Font.H5>

                <Font.P>{text}</Font.P>

                <Flexbox justify="flex-end">
                    <Button
                        to={!blank && toBtn}
                        as={blank ? "a" : Link}
                        href={blank && toBtn}
                        target={blank && "_blank"}
                        rel={blank && "noreferrer noopener"}
                        noPadding
                        buttonStyle="text"
                    >
                        {textBtn}
                    </Button>
                </Flexbox>
            </Content>
        </Container>
    )
}

export default CardHome
